import { inject, observer } from 'mobx-react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import withRouter from '@/components/withRouter';
import s from './styles/Event.module.scss';
import { useEffect, useState, useRef } from 'react';

import { Display } from '@/components/Display/Display';
import AnswerSheet from './components/AnswerSheet';
import { Button } from 'antd';
import FeedBackModal from './components/FeedBackModal';

import SimulationImg from '../components/SimulationImg';
import EnterImg from '@/components/CaseProgressCircle/EnterImg';
import eventImg from '@/assets/images/mobile/simulation/event.webp';
import doubleArrowImg from '@/assets/images/mobile/simulation/doubleArrow.webp';
import EventModal from './components/Modal/EventModal';
import useEvent from '@/pages/hooks/CaseSImulation/useEvent';
const EventCard = (props) => {
    const [showEventModal, setShowEventModal] = useState(false);
    const backRef = useRef(null);
    const [overflow, setOverflow] = useState(false);
    const { eventStatus, isFirst, errorMsg, resultModal, resultData, onSubmit, onNext, isCanSubmit, onReChose, onClickArrow } = useEvent({
        ...props,
        side: 'mobile'
    });
    const {
        store: { simulation }
    } = props;

    const {
        curEventIndex,
        events,

        curEventData,

        loading
    } = simulation;

    useEffect(() => {
        // 确保 Ref 已关联到真实 DOM 元素
        if (eventStatus !== 1) {
            const el = backRef.current;
            console.log(el.scrollHeight, el.clientHeight);

            const overflowY = el.scrollHeight > el.clientHeight;
            setOverflow(overflowY);
        }
    }, [eventStatus]);
    return (
        <>
            <FeedBackModal resultData={resultData} show={resultModal} onNext={onNext} onReChose={onReChose}></FeedBackModal>
            <EventModal show={showEventModal} onClose={() => setShowEventModal(false)}></EventModal>
            <div className={s['event-card-container']} data-type={eventStatus}>
                {/* 主内容区 */}
                <div className={s['main-content']}>
                    <Display show={eventStatus === 1}>
                        <div className={s['event-content']}>
                            <div className={s['progress']}>
                                <span className={s['progress-number']}>{curEventIndex + 1 < 10 ? '0' + (curEventIndex + 1) : curEventIndex + 1}</span>
                                <span className={s['progress-total']}>/{events.length < 10 ? '0' + events.length : events.length}</span>
                            </div>
                            {/* 事件标题 */}
                            <div className={s['event-title']}>{curEventData?.scenario_title}</div>
                            {/* 事件图片 */}
                            <div className={`${s['event-image-wrapper']} ${!isFirst ? s['fadeOut'] : ''}`}>
                                <SimulationImg src={curEventData?.scenario_image} alt={curEventData?.scenario_title} className={s['event-image']} />
                            </div>

                            {/* 文字说明 */}

                            <div className={s['event-desc-wrapper']}>
                                <div className={s['event-desc']} data-hidden={isFirst}>
                                    {curEventData?.scenario_description}
                                </div>
                            </div>

                            <Display show={!isFirst}>
                                <div className={s['arrow-wrapper']}>
                                    <EnterImg onclickArrow={onClickArrow}></EnterImg>
                                </div>
                            </Display>
                        </div>
                    </Display>
                    <Display show={eventStatus === 2}>
                        <div className={s['answer-content']}>
                            <div className={s['answer-event-content-wrapper']} onClick={() => setShowEventModal(true)}>
                                <div className={s['answer-event-back']}>
                                    <div className={s['left']}>
                                        <img src={eventImg} alt="" />
                                        <span className={s['answer-event-back-text']}>事件回顾</span>
                                    </div>
                                    <div className={s['right']}>
                                        查看详情
                                        <img src={doubleArrowImg} alt="" />
                                    </div>
                                </div>
                                <div data-overflow={overflow} ref={backRef} className={s['answer-event-content']}>
                                    {curEventData?.scenario_description}
                                </div>
                            </div>
                            <AnswerSheet></AnswerSheet>
                            <div className={s['submit-btn-wrapper']}>
                                <Button
                                    disabled={!isCanSubmit().canSubmit}
                                    loading={loading}
                                    onClick={onSubmit}
                                    type="primary"
                                    shape="round"
                                    size="large"
                                    className={s['submit-btn']}
                                >
                                    {loading ? '正在提交' : '提交'}
                                </Button>
                            </div>
                            <Display show={errorMsg}>
                                <div className={s['error-msg-wrapper']}>
                                    <ExclamationCircleOutlined />
                                    <span className={s['error-msg']}>分析失败，请重新提交</span>
                                </div>
                            </Display>
                        </div>
                    </Display>
                </div>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(EventCard)));
